"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteProductValue = exports.useCreateProductValue = void 0;
var use_create_product_value_hook_1 = require("./use-create-product-value.hook");
Object.defineProperty(exports, "useCreateProductValue", { enumerable: true, get: function () { return use_create_product_value_hook_1.useCreateProductValue; } });
var use_delete_product_value_hook_1 = require("./use-delete-product-value.hook");
Object.defineProperty(exports, "useDeleteProductValue", { enumerable: true, get: function () { return use_delete_product_value_hook_1.useDeleteProductValue; } });
